(async () => {
  if (!Object.values) {
    const values = await import('object.values');
    values.default.shim();
  }
})();
